import { AddQuestionsState } from 'author/src/features/addQuestions/reducer';
import { CheckboxProps } from 'semantic-ui-react';
import { SearchColumn } from '../store/common/search/types';

const shouldUpdateTitle = (
    state: AddQuestionsState
) => (
    state
  && state.table
  && state.table.dataType === 'content_qti_section'
  && window.marketplaceProperties.ENABLE_SYSTEM_GENERATED_CB_IDS
);

const columnTitleUpdater = (column: SearchColumn) => {
    if (column.ref === 'title') {
        return { ...column, ref: 'content_block_id', name: 'content_block_id' };
    }
    if (column.ref === 'Content Block ID') {
        return { ...column, ref: 'Migrated CB ID', name: 'Migrated CB ID' };
    }
    return column;
};

export const buildColumnTitleUpdater = (state: AddQuestionsState) => {
    if (shouldUpdateTitle(state)) {
        return columnTitleUpdater;
    }
    return (column: SearchColumn) => column;
};

export const toOriginalTitle = (data: CheckboxProps) => {
    if (data.id === 'Migrated CB ID') {
        return 'Content Block ID';
    }
    if (data.id === 'content_block_id') {
        return 'title';
    }
    return data.id;
};
